import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { EditorComponent } from '@tinymce/tinymce-angular';

@Component({
  selector: 'app-meeting-record-personal-notes-tab',
  templateUrl: './meeting-record-personal-notes-tab.component.html',
  styleUrls: ['./meeting-record-personal-notes-tab.component.css', '../meeting-record-editor-tab.styles.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, EditorComponent],
})
export class MeetingRecordPersonalNotesTabComponent {
  is_create = input.required<boolean>();

  personal_notes_control = input.required<FormControl<string>>();

  tiny_mce_api_key = input.required<string>();

  tiny_mce_init = input.required<Record<string, unknown>>();
}
